import { createReducer, on } from '@ngrx/store';
import * as OfficerDetailActions from './officer-details.store.actions';
import { initialState } from './officer-details-store.state';

export const OfficerDetailsReducer = createReducer(
  initialState,
  on(OfficerDetailActions.getCurrentOfficerSuccess, (state, { officer }) => {
    return {
      ...state,
      loggedInOfficer: officer,
    };
  }),
  on(OfficerDetailActions.changeAutoClearFiltersSuccess, (state, { newAutoClearFiltersValue }) => {
    if (state.loggedInOfficer) {
      return {
        ...state,
        loggedInOfficer: {
          ...state.loggedInOfficer,
          autoClearFilters: newAutoClearFiltersValue,
        },
      };
    }

    return state;
  }),
  on(OfficerDetailActions.updateCurrentOfficerSuccess, (state, { officer }) => {
    return {
      ...state,
      loggedInOfficer: officer,
    };
  })
);
